function Footer() {
    return (
        <footer className="text-left p-2 bg-dark text-white">
        <p className="float-right"><a href="#">Back to top</a></p>
        <p>© 2020-2021 <span className="text-danger">FoodSaver</span>, Inc. · <a href="#">Privacy</a> · <a href="#">Terms</a></p>
      </footer>
    )
}

export default Footer;
